/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getI64Decoder,
  getI64Encoder,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type TagDecayAppliedEvent = {
  agent: Address;
  tagsRemoved: number;
  remainingTags: number;
  timestamp: bigint;
};

export type TagDecayAppliedEventArgs = {
  agent: Address;
  tagsRemoved: number;
  remainingTags: number;
  timestamp: number | bigint;
};

export function getTagDecayAppliedEventEncoder(): FixedSizeEncoder<TagDecayAppliedEventArgs> {
  return getStructEncoder([
    ["agent", getAddressEncoder()],
    ["tagsRemoved", getU32Encoder()],
    ["remainingTags", getU32Encoder()],
    ["timestamp", getI64Encoder()],
  ]);
}

export function getTagDecayAppliedEventDecoder(): FixedSizeDecoder<TagDecayAppliedEvent> {
  return getStructDecoder([
    ["agent", getAddressDecoder()],
    ["tagsRemoved", getU32Decoder()],
    ["remainingTags", getU32Decoder()],
    ["timestamp", getI64Decoder()],
  ]);
}

export function getTagDecayAppliedEventCodec(): FixedSizeCodec<
  TagDecayAppliedEventArgs,
  TagDecayAppliedEvent
> {
  return combineCodec(
    getTagDecayAppliedEventEncoder(),
    getTagDecayAppliedEventDecoder(),
  );
}
